import React from 'react';
import { CRow } from '@coreui/react';

import appleLogo from '../../assets/images/appstore.svg';
import googleLogo from '../../assets/images/google-play-badge.png';

const SetupNextSteps = () => {

  return (
    <>
      <h3 className='text-center'>You are all set!</h3>
      <p className='text-center mb-4'>
        Install the Glympse Pro app to finish your setup.
      </p>
      <CRow>
        <a className="d-block mx-auto" href="https://apps.apple.com/us/app/glympse-pro/id1589828565">
          <img src={ appleLogo } height="50" alt="links to the iOS app store" />
        </a>
      </CRow>
      <CRow>
        <a className="d-block mx-auto" href="https://play.google.com/store/apps/details?id=com.glympse.android.pro">
          <img src={ googleLogo } height="70" alt="links to the Google Play store" />
        </a>
      </CRow>
    </>
  );
};

export default SetupNextSteps;